module.exports = __webpack_public_path__ + "img/725e3fa.png";